<table class="ir-plugin-table" style="margin-bottom: 10px" *ngFor="let status of statuses">
  <tr *ngIf="status.Label">
    <td class="th-plugin-line--subheader plugin-table-cell">
      <span>
        <strong>{{ status.Label }}</strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <p>
        <span class="ir-ph1 ir-installationreceived_comment"></span>
      </p>
    </td>
  </tr>
  <tr *ngIf="status.Status >= 0">
    <td class="th-plugin-line--subheader plugin-table-cell">
      <span>
        <strong>{{ 'plugins.installationstatus.name' | translate }}</strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <p>
        <span class="ir-ph1">{{ status.Status | statustype }}</span>
      </p>
    </td>
  </tr>
</table>
